import React, { DetailedHTMLProps, HTMLAttributes } from 'react'
import { cn } from '@/lib/ui/utils'

export const Skeleton: React.FC<
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = ({ className, children, ...props }) => {
  return (
    <div
      data-slot="skeleton"
      className={cn('bg-accent animate-pulse rounded-md', className)}
      {...props}
    >
      {children}
    </div>
  )
}
